export default {
  duplicate: {
    id: 'listing_detail_duplicate',
    defaultMessage: 'Duplicate listing',
  },
  itemId: {
    id: 'listings_detail_item_id',
    defaultMessage: 'Item Id:',
  },
  gradeShiny: {
    id: 'grade_shiny',
    defaultMessage: 'Mint',
  },
  gradeGold: {
    id: 'grade_gold',
    defaultMessage: 'Very good',
  },
  gradeSilver: {
    id: 'grade_silver',
    defaultMessage: 'Good',
  },
  gradeBronze: {
    id: 'grade_bronze',
    defaultMessage: 'Fair',
  },
  gradeStallone: {
    id: 'grade_stallone',
    defaultMessage: 'Stallone',
  },
  gradePremium: {
    id: 'grade_premium',
    defaultMessage: 'Premium',
  },
  grade: {
    id: 'listings_offer_grade',
    defaultMessage: 'Aesthetic grade: {grade, html}',
  },
  sku: {
    id: 'listings_offer_edit_sku',
    defaultMessage: 'SKU',
  },
  save: {
    id: 'listings_offer_edit_sku_save',
    defaultMessage: 'Save',
  },
}
